import type { AppointmentType, BookingResponse } from '@dialogue/timekeeper'

import type { AppointmentBookingExplicitProps } from './types'

export type DerivedBookingFields = Pick<
  AppointmentBookingExplicitProps,
  'date_from' | 'date_until' | 'appointment_type'
>

export type DerivedBookingPropName = keyof DerivedBookingFields

/**
 * Derives the flat scheduling props from a booking object.
 */
export const deriveBookingProps = (
  booking: BookingResponse | null | undefined
): Partial<DerivedBookingFields> => {
  if (!booking?.booking_window) {
    return {}
  }

  return {
    date_from: booking.booking_window.start_at,
    date_until: booking.booking_window.end_at,
    appointment_type: booking.dialogue_metadata.appointment_type[0] as AppointmentType,
  }
}
